module.exports = __webpack_public_path__ + "img/play.64fecff6.svg";